module.exports = __webpack_public_path__ + "static/intro-movie-8038cb745cd7bdff636899eeff728f70.mp4";